import { screenNames } from './app/constants/screens';

const meta = require('../data/meta.json');

// eslint-disable-next-line no-unused-vars
const { yaMetrikaId } = meta;
const defaultAnalyticsEventType = 'reachGoal';

export default class Analytics {
    static isGuest = true;
    static screen = null;

    static sendEvent(eventName, eventType = defaultAnalyticsEventType) {

        if (eventName === 'global_betcity-logo-click') {
            if (this.screen === screenNames.RESULTS) {
                eventName = 'result-{authStatus}_logo-click';
            }
            if (this.screen === screenNames.SCORING) {
                eventName = 'winners_logo-click';
            }
        }

        const authString = this.isGuest ? 'unauthorized' : 'user';
        const formattedName = eventName.replace('{authStatus}', authString);

        console.log(`Analytics ${eventType}, ${formattedName}. Screen: ${this.screen}, Guest: ${this.isGuest}`);

        if (!window.ym) return;

        window.ym(yaMetrikaId, eventType, formattedName);
    }

    static initOnClickEvents = () => {
        const elementsToTrack = Array.from(document.querySelectorAll('[data-analytics-event]'));

        elementsToTrack.forEach((el) => {
            el.addEventListener('click', () => {
                const eventName = el.dataset.analyticsEvent;
                const eventType = el.dataset.analyticsEventType || defaultAnalyticsEventType;

                this.sendEvent(eventName, eventType);
            });
        });
    };
}
